import { istGueltigeAdresse } from '../emails/empfaenger';
import type { KanalZeile } from './typen';

/**
 * Die eine Adresse, an die dieser Empfaenger geschrieben wird.
 *
 * Reihenfolge: als primaer markierter E-Mail-Kanal, sonst der mit der kleinsten
 * Sortierung, sonst das alte Feld am Datensatz. Ungueltige Werte (anhaengendes
 * Semikolon, fehlendes @) gelten als nicht vorhanden — Graph lehnt sonst die GANZE
 * Mail ab (Live-Bug 2026-08-13, siehe lib/emails/empfaenger.ts).
 *
 * Mehrfachadressen sind im Bestand ein Einzelfall (genau ein aktiver Mieter), die
 * Reihenfolge ist also selten entscheidend — aber sie muss festgelegt sein.
 */
export function waehleAdresse(kanaele: KanalZeile[], feldEmail: string | null): string | null {
  const mails = (kanaele || [])
    .filter((k) => k.kanal === 'email' && istGueltigeAdresse(k.wert))
    .sort((a, b) => Number(b.ist_primaer) - Number(a.ist_primaer) || a.sortierung - b.sortierung);
  if (mails.length > 0) return mails[0].wert.trim();
  const feld = (feldEmail || '').trim();
  return feld && istGueltigeAdresse(feld) ? feld : null;
}
